<div class="view_icons_container">
  <button mat-icon-button  (click)="_view.list_view ? _view.gridView() : _view.listView()">
    <mat-icon [ngClass]="{'selectedView': _view.grid_view}" >
      {{ _view.list_view ? 'grid_view' : 'view_list' }}
    </mat-icon>
  </button>
</div>
